/**
 * The errors a cell can hold. These are values, not exceptions: a spreadsheet
 * keeps calculating around a bad cell, and a single `#VALUE!` in the middle of
 * a ledger must not take down the other four hundred rows.
 */
export const ERROR_CODES = [
    '#DIV/0!',
    '#VALUE!',
    '#REF!',
    '#NAME?',
    '#NUM!',
    '#N/A',
    '#CYCLE!',
];
export const BLANK = { kind: 'blank' };
export function numberValue(value) {
    return { kind: 'number', value };
}
export function textValue(value) {
    return { kind: 'text', value };
}
export function booleanValue(value) {
    return { kind: 'boolean', value };
}
export function errorValue(code) {
    return { kind: 'error', code };
}
export function isError(value) {
    return value.kind === 'error';
}
//# sourceMappingURL=types.js.map